var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "form__wrapper" },
        [
          _c(
            "div",
            { staticClass: "form__userpic" },
            [_c("userpic", { attrs: { url: _vm.user && _vm.user.photo } })],
            1
          ),
          _c("c-textarea", {
            staticClass: "form__field",
            attrs: { placeholder: "Напишите комментарий", clearable: true },
            model: {
              value: _vm.text,
              callback: function ($$v) {
                _vm.text = $$v
              },
              expression: "text",
            },
          }),
          _c("div", { staticClass: "form__actions" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "b-popover",
                    rawName: "v-b-popover.html",
                    value: {
                      id: "comment-form-add-file",
                      container: "#app",

                      content: "Добавить файл",
                      trigger: "hover",
                      placement: "top",
                    },
                    expression:
                      "{\n          id: 'comment-form-add-file',\n          container: '#app',\n\n          content: 'Добавить файл',\n          trigger: 'hover',\n          placement: 'top',\n        }",
                    modifiers: { html: true },
                  },
                ],
                staticClass: "form__attach",
                attrs: {
                  type: "button",
                  disabled: _vm.fileLinks.length + _vm.files.length >= 10,
                },
                on: { click: _vm.chooseFiles },
              },
              [_c("svg-icon", { attrs: { size: 16, name: "clip" } })],
              1
            ),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "b-popover",
                    rawName: "v-b-popover.html",
                    value: {
                      id: "comment-form-submit",
                      container: "#app",

                      content: "Добавить комментарий",
                      trigger: "hover",
                      placement: "top",
                    },
                    expression:
                      "{\n          id: 'comment-form-submit',\n          container: '#app',\n\n          content: 'Добавить комментарий',\n          trigger: 'hover',\n          placement: 'top',\n        }",
                    modifiers: { html: true },
                  },
                ],
                staticClass: "form__submit",
                attrs: {
                  type: "submit",
                  disabled: !_vm.isValid || _vm.pending,
                },
              },
              [
                _c("svg-icon", {
                  attrs: { size: 15, name: "submit", color: "white" },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "form__files",
          class: { empty: !_vm.fileLinks.length && !_vm.files.length },
        },
        [
          _c("file-loader", {
            ref: "loader",
            attrs: {
              format: "images,pdf,docs,video",
              actions: "loadFiles,preview",
              links: _vm.fileLinks,
              limit: 10,
            },
            on: {
              changeLinks: function ($event) {
                _vm.fileLinks = $event
              },
            },
            model: {
              value: _vm.files,
              callback: function ($$v) {
                _vm.files = $$v
              },
              expression: "files",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }